import { IModuleNavigationData } from './navigation';

export interface IConceptLinkerAiLinker {
  id: number;
  name: string;
  user_id: number;
  user_name: string;
  created_date: string;
  course_id: number;
  entity_type: string;
  target_dialect_ids: number[];
  lesson_start: number;
  lesson_end: number | null;
  status: number;
  status_label: string;
  priority: number;
  items_count: number;
}

export interface IConceptLinkerAiLinkerEdit {
  id: number;
  name: string;
  user_id: number;
  user_name: string;
  created_date: string;
  course_id: number;
  entity_type: string;
  target_dialect_ids: number[];
  lesson_start: number;
  lesson_end: number | null;
  status: number;
  status_label: string;
  priority: number;
  items_count: number;
}

export interface IConceptLinkerAiLinkerCreate {
  courseId: number;
  entityType: string;
  lessonStart: number;
  lessonEnd: number | null;
}

export interface IConceptLinkerAiLinkerDialectResult {
  dialect_id: number;
  dialect_entity_id: number;
  text: string;
  phrases: Array<{
    phrase: string;
    order: number;
    concepts: Array<{
      ref: number;
      refId: number;
      positions: number[];
      inflectStudied: string;
      deltaPos: number;
      name?: string;
      aiSelected?: boolean;
    }>;
  }>;
  coverage: number;
  unlinked_positions: Array<{ phrase_order: number; position: number }>;
  reasoning: string | null;
}

export interface IConceptLinkerAiLinkerItemAiResult {
  dialects: Record<string, IConceptLinkerAiLinkerDialectResult>;
}

export interface IConceptLinkerAiLinkerItem {
  id: number;
  job_id: number;
  course_id: number;
  entity_ref: number;
  entity_ref_id: number;
  entity_type: string;
  status: number;
  status_label: string;
  ai_result: IConceptLinkerAiLinkerItemAiResult | null;
  async_task_status: number;
  ai_processed_date: string | null;
  decision: 'reviewed' | null;
  navigation_data: IModuleNavigationData;
}

export enum ConceptLinkerAiLinkerItemStatus {
  PENDING = 0,
  NEEDS_REVIEW = 1,
  DONE = 3,
  ERROR = 4,
}

export enum ConceptLinkerAiLinkerJobStatus {
  PENDING = 0,
  NEEDS_REVIEW = 1,
  DONE = 2,
}
